module.exports = __webpack_public_path__ + "img/4.4f4f20d4.png";